module.exports = __webpack_public_path__ + "img/icone-boas-vindas.aa6d1d8a.svg";